import React, { useRef, useEffect, useImperativeHandle } from 'react';
import { usePortal } from '@pansy/use-portal';
import { useMap } from "../map";
import { usePropsReactive } from "../utils";
import { allProps, converterMap } from "./config";
import { jsx as _jsx } from "react/jsx-runtime";
export var InfoWindow = /*#__PURE__*/React.forwardRef(function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ref = arguments.length > 1 ? arguments[1] : undefined;
  var _useMap = useMap(),
    map = _useMap.map,
    AMap = _useMap.AMap;
  var _usePortal = usePortal(),
    container = _usePortal.container,
    Portal = _usePortal.Portal;
  var instanceObj = useRef(null);
  var setterMap = {
    visible: function visible(val) {
      if (val) {
        showWindow();
        setClassName();
      } else {
        closeWindow();
      }
    }
  };
  var _usePropsReactive = usePropsReactive(props, instanceObj, {
      setterMap: setterMap,
      converterMap: converterMap
    }),
    onInstanceCreated = _usePropsReactive.onInstanceCreated;
  useEffect(function () {
    if (map) {
      createInstance().then(function () {
        onInstanceCreated === null || onInstanceCreated === void 0 ? void 0 : onInstanceCreated(instanceObj.current);
      });
    }
  }, [map]);
  useEffect(function () {
    refreshWindowLayout();
  }, [props.children, props.className]);
  useImperativeHandle(ref, function () {
    return instanceObj.current;
  }, [instanceObj.current]);
  var createInstance = function createInstance() {
    var options = buildCreateOptions(props);
    instanceObj.current = new AMap.InfoWindow(options);
    return Promise.resolve();
  };
  var refreshWindowLayout = function refreshWindowLayout() {
    setClassName();
  };
  var buildCreateOptions = function buildCreateOptions(props) {
    var options = {};

    // 如果开发者没有设置 isCustom 属性，默认设置为 false
    if ('isCustom' in props) {
      options.isCustom = !!props.isCustom;
    } else {
      options.isCustom = false;
    }
    if ('content' in props) {
      options.content = props.content;
    } else {
      options.content = container;
    }
    allProps.forEach(function (key) {
      if (key in props) {
        if (['visible', 'isCustom', 'content'].indexOf(key) === -1) {
          options[key] = getSetterValue(key, props);
        }
      }
    });
    return options;
  };
  var getSetterValue = function getSetterValue(key, props) {
    if (key in converterMap) {
      return converterMap[key](props[key]);
    }
    return props[key];
  };
  var showWindow = function showWindow() {
    if (instanceObj.current) {
      instanceObj.current.open(map, instanceObj.current.getPosition());
    }
  };
  var closeWindow = function closeWindow() {
    if (instanceObj.current) {
      instanceObj.current.close();
    }
  };
  var setClassName = function setClassName() {
    if (container) {
      var baseClsValue = '';
      // 刷新 className
      if ('className' in props && props.className) {
        baseClsValue += props.className;
      } else if (props.isCustom === true) {
        baseClsValue += 'amap_markers_pop_window';
      }
      container.className = baseClsValue;
    }
  };
  return /*#__PURE__*/_jsx(Portal, {
    children: props.children
  });
});